import { api } from "@/lib/api";
import { toast } from "sonner";
import { Flag } from "lucide-react";

export default function MarkRoundsTab({ tournament, onChanged }) {
    const stageKeys = new Set((tournament.stages || []).map(s => s.key));
    const eligible = ["r64", "r32", "r16", "qf", "sf", "final"].filter(s => stageKeys.has(s));

    const handleMarkRound = async (stage) => {
        await api.markRoundStarted(tournament.id, { stage });
        toast.success(`Marked ${stage} as started`);
        onChanged?.();
    };

    return (
        <div className="brutal-card p-5 space-y-4">
            <h2 className="font-display font-extrabold text-xl uppercase">Mark Rounds Started</h2>
            <p className="text-xs text-zinc-500">Locks knockout bonus picks at decreasing point values when a round starts. Only the rounds present in this tournament's bracket are shown.</p>
            {eligible.length === 0 ? (
                <p className="text-sm text-zinc-500" data-testid="mark-rounds-empty">No knockout rounds in this format — nothing to mark.</p>
            ) : (
                <div className="grid sm:grid-cols-2 gap-3">
                    {eligible.map(s => (
                        <div key={s} data-testid={`mark-round-row-${s}`} className="flex items-center justify-between p-3 border-2 border-[#333] rounded-md bg-ink">
                            <div>
                                <p className="font-bold uppercase">{s}</p>
                                <p className="text-[10px] text-zinc-500">{tournament.round_started?.[s] ? "STARTED" : "Not started"}</p>
                            </div>
                            <button
                                data-testid={`mark-round-${s}-btn`}
                                onClick={() => handleMarkRound(s)}
                                disabled={tournament.round_started?.[s]}
                                className={`brutal-btn text-xs py-2 ${tournament.round_started?.[s] ? "bg-neon/20 border-neon text-neon shadow-none" : "bg-cyber text-black"}`}>
                                <Flag className="w-3 h-3" />
                                {tournament.round_started?.[s] ? "Started" : "Mark started"}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
